// dependencies
import { useQuery } from "@tanstack/react-query";

import { GetUserResponseJSON } from "@performyard/service-contracts";

import { getInternalApiUserQuery } from "../../../api/queries";

import { User, fetchUserInformation } from "../../services";
import { PYUseQueryOptions } from "../StandardQueryArguments";

type useUserProps = {
	userID?: string;
	disabled?: boolean;
};

export const useUser = ({ userID = "", disabled = false }: useUserProps) => {
	const query = useQuery<User>({
		queryKey: ["User", userID],
		queryFn: () => fetchUserInformation(userID),
		meta: {
			errorMessage: "There was an error getting user information.",
		},
		enabled: !disabled && !!userID,
	});

	return query;
};

export const useInternalApiUser = (userID: string, options?: PYUseQueryOptions<GetUserResponseJSON>) => {
	return useQuery<GetUserResponseJSON>(getInternalApiUserQuery(userID, options));
};
